/* eslint-disable */
import { ReactReportContext } from "@sa/rep-react";
import * as React from "react";
import { SingleValueParameter, MultiValueParameter } from "@sa/rep-core";
import { useDictionary } from "./useDictionary";
import { DictionaryItem, DictionariesService } from "@sa/rep-mdm";

export function useDictionaryItem(service: DictionariesService, dictionary: string, itemId: unknown, parameters?: Record<string, unknown>): [DictionaryItem | null, string | null | undefined] {
  const checkId = itemId !== null && itemId !== undefined && !isNaN(itemId as number); 
  const [items] = useDictionary(service, checkId ? dictionary : undefined, undefined, parameters);
  const item = React.useMemo(() => items && items.find(x => String(x.id) === String(itemId))!, [items, itemId]);
  const itemName = React.useMemo(() => item && item.getSingleValue<string>("name"), [item]);
  return [item, itemName];
}
